import React from "react"
import Section from "../../../../core/layout/main/section/Section"
import { Swiper, SwiperSlide } from "swiper/react"
import PressCardBlock from "../../blocks/press-card-block/PressCardBlock"
import Button from "../../blocks/button/Button"
import *  as classNames from "./LastCommuniquesPressSlider.module.scss"

function LastCommuniquesPressSlider({
  title,
  subTitle,
  buttonCtaLink,
  buttonText,
  isPdfButton,
  pageContext,
}) {
  const { communiquesPresse } = pageContext
  return (
    <Section classNames={classNames.LastCommuniquesPressSlider + " mt-4"}>
      <h2>{title}</h2>
      <p className="mt-2">{subTitle}</p>
      <Swiper
        spaceBetween={36}
        slidesPerView={2.2}
        className={classNames.LastCommuniquesPressSwiper}
        breakpoints={{
            0: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 1.3,
            },
            1024: {
                slidesPerView: 2.2,
            },
            }}
        style={{
          paddingInline: "30px",
          paddingBottom: "20px",
        }}
      >
        {communiquesPresse
          .slice()
          .sort(
            (a, b) => new Date(b.attributes.date) - new Date(a.attributes.date)
          ) // Sort articles by date in descending order
          .filter(
            (communiquePresse) =>
              new Date(communiquePresse.attributes.date) <= new Date()
          ) // Filter out articles with a date greater than today's date
          .slice(0, 4)
          .map((communique) => (
            <SwiperSlide>
              <PressCardBlock
                data={communique}
                key={communique.id}
                isPdfButton={isPdfButton}
              />
            </SwiperSlide>
          ))}
      </Swiper>

      <div className={classNames.LastCommuniquesPressSliderBtn + " mt-4 mb-4"}>
        <Button
          aspect={"classique"}
          color={"primary"}
          size={"large"}
          ctalink={buttonCtaLink}
        >
          {buttonText}
        </Button>
      </div>
    </Section>
  )
}
export const name = "LastCommuniquesPressSlider"

export const init = (componentData, pageContext) => {
  return (
    <LastCommuniquesPressSlider
      title={componentData.label}
      subTitle={componentData.subTitle}
      buttonCtaLink={componentData.buttonCtaLink}
      buttonText={componentData.buttonText}
      isPdfButton={componentData.isPdfButton}
      pageContext={pageContext}
    />
  )
}
export default LastCommuniquesPressSlider
